export default "__VITE_ASSET__HN7vzzLk__"